export default __webpack_public_path__ + "static/media/img3.2bd96b3c.jpg";